export default "__VITE_ASSET__DfckcfyP__"